<template>
    <div v-if="Object.keys(privacyDocument).length">
        <privacy-document-view
            :document="privacyDocument"
            :no-body="true"
        >
            <template #title>
                <span>{{ $t("org.agreement.agreementToCollectAndUsePersonalInformation") }}</span>
            </template>
            <template #agreement v-if="authPrerequisites.includes('tc')">
                <b-badge
                    class="d-block p-2 font-small-4"
                    variant="danger"
                >
                    <p class="mb-0">
                        {{$t("org.agreement.youCanKeepUsingIfYouAgree")}}
                    </p>
                </b-badge>
            </template>
            <template #agreement v-else>
                <b-badge
                    class="d-block p-2 font-small-4"
                    variant="success"
                >
                    <p class="mb-0">
                        {{ $t("org.agreement.agreeToTermsOfService")}}
                    </p>
                </b-badge>
            </template>
            <template
                #button
            >
                <b-button variant="primary" @click="signAgreement" :disabled="disabledValue">
                    <feather-icon icon="CheckSquareIcon" />
                    <span class="ml-1">{{ $t('org.agreement.iAgreeToTermsOfServiceAbove') }}</span>
                </b-button>
            </template>
        </privacy-document-view>
    </div>
    <div v-else>
        <b-button variant="primary" @click="signAgreement" :disabled="disabledValue">
            <feather-icon icon="CheckSquareIcon" />
            <span class="ml-1">{{ $t('org.agreement.iAgreeToTermsOfServiceAbove') }}</span>
        </b-button>
    </div>
</template>

<script>
import { getCurrentInstance, computed, ref, watch, onMounted } from '@vue/composition-api'
import utils from '@/auth/utils'
import PrivacyDocumentView from './Shared/PrivacyDocumentView'

export default {
    components: {
        PrivacyDocumentView
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const requestFlag = ref(false)
        const locale = computed(() => vm.$i18n.locale)
        const authUserInfo = computed(() => store.getters.authUserInfo)
        const authPrerequisites = computed(() => store.getters.authPrerequisites)
        const privacyDocument = computed(() => store.getters.privacyDocument)
        const disabledValue = computed(() => requestFlag.value ? 'disabled' : undefined)
        const scrollTo = (index) => {
            window.scrollTo({ top: document.getElementById('content' + index).offsetTop + 50, behavior: 'smooth' })
        }
        const signAgreement = () => {
            if (requestFlag.value) {
                return
            }
            utils.isUserLoggedIn().then(() => {
                requestFlag.value = true
                store.dispatch('signAgreement', { userIdx: authUserInfo.value.userIdx, signedTc: true }).then(() => {
                    store.dispatch('createTokenAuth', { email: authUserInfo.value.email }).then(() => {
                        const nextPath = utils.getRouteForLoggedInUser()
                        utils.isUserMonths().then(haveBilingData => {
                            vm.$router.push(haveBilingData ? nextPath : { name: 'infomation' })
                        })
                    })
                })
            })
        }

        const getVersions = () => {
            store.dispatch('getAgreementDocumentVersions', { locale: locale.value }).then(() => {
                store.dispatch('getAgreementDocumentContent', { locale: locale.value, version: store.getters.privacyDocumentVersions[0] })
            })
        }

        watch(() => locale.value, () => {
            getVersions()
        })

        onMounted(() => {
            getVersions()
        })

        return {
            disabledValue,
            authPrerequisites,
            scrollTo,
            signAgreement,
            privacyDocument
        }
    }
}
</script>

<style>

</style>
